import {createSlice} from '@reduxjs/toolkit';

interface DevicesState {
  isWebView: boolean;
}

const initialState: DevicesState = {
  isWebView: false,
};

const devicesSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    setWebView: state => {
      state.isWebView = true;
    },
    unSetWebView: state => {
      state.isWebView = false;
    },
  },
});

export const {setWebView, unSetWebView} = devicesSlice.actions;
export default devicesSlice.reducer;
